// start:ng42.barrel
export * from './points-estimation.component';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/points-estimation/index.ts